export enum DailyHubOperationDrillTypeInput {
    NOT_OUTBOUND_SCANNED = 'NOT_OUTBOUND_SCANNED',
    SHOULD_ARRIVE_NOT_ARRIVE = 'SHOULD_ARRIVE_NOT_ARRIVE',
    OUTBOUND_EXCEED_12H = 'OUTBOUND_EXCEED_12H',
    NO_ASCAN_DELIVERY = 'NO_ASCAN_DELIVERY',
    OUTBOUND_MISSED_SCAN = 'OUTBOUND_MISSED_SCAN',
    TRANSFER_ARRIVAL_MISSED_SCAN = 'TRANSFER_ARRIVAL_MISSED_SCAN',
    OVERALL_MISS_SCAN = 'OVERALL_MISS_SCAN',
    WRONG_SORT = 'WRONG_SORT',
    WRONG_SORT_TO_WRONG_LINE_AB = 'WRONG_SORT_TO_WRONG_LINE_AB',
    WRONG_SORT_TO_WRONG_HUB_A = 'WRONG_SORT_TO_WRONG_HUB_A',
    WRONG_SORT_TO_WRONG_WHS_B = 'WRONG_SORT_TO_WRONG_WHS_B',
    WRONG_SORT_TO_WRONG_LINE_C = 'WRONG_SORT_TO_WRONG_LINE_C',
    NEXT_DAY_HANDOVER = 'NEXT_DAY_HANDOVER',
    SHOULD_ARRIVE_NOT_CORRECTLY_PACKED = 'SHOULD_ARRIVE_NOT_CORRECTLY_PACKED',
    SHOULD_ARRIVE_BAG_LABEL_NOT_SHIPPED = 'SHOULD_ARRIVE_BAG_LABEL_NOT_SHIPPED',
    SHOULD_ARRIVE_NO_DEPARTURE_ACTION = 'SHOULD_ARRIVE_NO_DEPARTURE_ACTION',
}

export interface DailyHubOperationDetailType {
    id: string;
    orderId: number;
    trackingNumber: string;
    hubId: number;
    hubName: string;
    /** 明细表客户维度（与汇总 customer_name 一致）；null 表示汇总行 */
    customerName?: string | null;
    /** 仓库类型：1=分拣仓，2=尾程仓；0 表示历史数据未回填 */
    businessType?: number | null;
    /** 是否次日交接：0 否 1 是 */
    isNextDayHandover?: number | null;
    /** 客户名称（渠道名称），来自后端 GraphQL 计算字段 */
    clientName?: string | null;
    /** 运单状态（overall_status），与 WMS parcels 页面一致 */
    overallStatus?: string | null;
    arrivalTime: string | null;
    departureTime: string | null;
    deliveryTime: string | null;
    /** 错分下钻：错分至错误HUB/WHS/线路（后端中文文案） */
    wrongSortType?: string | null;
    shouldDeliveryAddress?: string | null;
    actualDeliveryAddress?: string | null;
    currentNoUpdateHours?: string | null;
    lastTrackingUpdateTime?: string | null;
    maxNoUpdateHours?: string | null;
    /** 0否、1错分过一段码、2错分过二段码 */
    noUpdateWrongSortEverStatus: number;
    statDate: string;
    lastSortOperationAccountName?: string | null;
    lastSortOperationAccountRole?: string | null;
    wrongLineMissortScanDriverName?: string | null;
    wrongLineMissortScanDspName?: string | null;
    /** 尾程服务商名称（分拣仓明细专用） */
    lastMileServiceProviderName?: string | null;
    /** 分拣仓错误类型：0-无 1-未正确装包 2-包牌未装车 3-没有发车动作 */
    sortErrorType?: number | null;
    /** 错分逻辑类别：0-未标注 1-下游提报 2-仓内 logscan 三段码不匹配 */
    missortedLogicType?: number | null;
    /** 分拣仓内最后一次扫描账号名 */
    lastSortingHubScanAccountName?: string | null;
    /** 分拣仓内最后一次扫描时间(UTC) */
    lastSortingHubScanTime?: string | null;
    /** 分拣仓内最后一次轨迹节点名 */
    lastSortingHubScanTrackingEvent?: string | null;
    /** 分拣仓内最后一次包牌号 */
    lastSortingHubScanBagNumber?: string | null;
    /** 最后一次装包是否正确：1-正确，0-不正确，null-无装包记录 */
    isLastBaggingCorrect?: number | null;
    /** 最后一次装包的包牌号 */
    lastBaggingBagNumber?: string | null;
    /** 最后分拣操作时间(UTC)；来自 order_wms.final_sc_at */
    lastSortOperationTime?: string | null;
    /** 外部分拣码；来自 order_wms.ext_sorting_rule */
    extSortingRule?: string | null;
}

export interface DailyHubOperationDetailPageRequestInput {
    statDateStart: string;
    statDateEnd: string;
    hubId?: number;
    hubIds?: number[] | null;
    drillType: DailyHubOperationDrillTypeInput;
    page?: number;
    size?: number;
    sortBy?: string | null;
    sortDirection?: string | null;
    customerName?: string | null;
    /** 仓库类型：1=分拣仓，2=尾程仓；缺省为 1 */
    businessType?: number | null;
}

export interface SortingDetailDownloadFilterInput {
    statDateStart: string;
    statDateEnd: string;
    hubId?: number;
    hubIds?: number[] | null;
    drillType: DailyHubOperationDrillTypeInput;
    ids?: string[] | null;
    customerName?: string | null;
    /** 仓库类型：1=分拣仓，2=尾程仓；缺省为 1 */
    businessType?: number | null;
}

export interface SortingHourlyDetailDownloadFilterInput {
    statDateStart: string;
    statDateEnd: string;
    windowStartHour?: number;
    windowEndHour?: number;
    hubId?: number;
    hubIds?: number[] | null;
    drillType: DailyHubOperationDrillTypeInput;
    ids?: string[] | null;
    customerName?: string | null;
    /** 仓库类型：1=分拣仓，2=尾程仓；缺省为 1 */
    businessType?: number | null;
}

export interface DailyHubOperationDetailPageResponseType {
    content: DailyHubOperationDetailType[];
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
    hasNext: boolean;
    hasPrevious: boolean;
}

export interface QueryDailyHubOperationDetailListResponse {
    queryDailyHubOperationDetailList: DailyHubOperationDetailPageResponseType;
}
